import {
  SET_BOOKING_FORM_VISIBILITY,
  SET_MESSAGE,
  GEOLOCATION_GET_USER_LOCATION,
} from '../constants';

export const setBookingFormVisible = visible => ({
  type: SET_BOOKING_FORM_VISIBILITY,
  visible,
});

export const setMessage = message => ({
  type: SET_MESSAGE,
  message,
});

export const setIsGettingUserLocation = status => ({
  type: GEOLOCATION_GET_USER_LOCATION,
  status,
});



// WEBPACK FOOTER //
// ./src/actions/ux.js